import { render, staticRenderFns } from "./Kurzzeitpflege.vue?vue&type=template&id=49834bfc&"
import script from "./Kurzzeitpflege.vue?vue&type=script&lang=js&"
export * from "./Kurzzeitpflege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports